import { motion } from "framer-motion";
import {
    Magnet, CalendarCheck, MonitorSmartphone, Bot, Megaphone, Clapperboard, Video, PenLine,
} from "lucide-react";

const SERVICES = [
    { n: "01", title: "Lead Generation", desc: "Predictable systems that bring qualified prospects into your business.", icon: Magnet },
    { n: "02", title: "Appointment Setting", desc: "Turn incoming interest into booked conversations and appointments.", icon: CalendarCheck },
    { n: "03", title: "Websites & Applications", desc: "Websites, landing pages, web apps and digital experiences designed to convert.", icon: MonitorSmartphone },
    { n: "04", title: "AI & Automation", desc: "Automate repetitive processes, lead handling, follow-ups and business workflows.", icon: Bot },
    { n: "05", title: "Digital Marketing", desc: "Paid media, Meta Ads, Google Ads, SEO and growth campaigns.", icon: Megaphone },
    { n: "06", title: "Media Production", desc: "The visual content needed to make brands stand out.", icon: Clapperboard },
    { n: "07", title: "UGC & Content", desc: "Authentic content designed for attention, engagement and conversion.", icon: Video },
    { n: "08", title: "Copywriting", desc: "Words that turn attention into action.", icon: PenLine },
];

const Card = ({ s, i }) => (
    <motion.div
        data-testid={`service-card-${s.n}`}
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
        onMouseMove={(e) => {
            const r = e.currentTarget.getBoundingClientRect();
            e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
            e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
        }}
        className="service-card group flex min-h-[230px] flex-col justify-between border-2 border-ink/15 bg-[#FFFDF6] p-6"
    >
        <div className="flex items-start justify-between">
            <span className="font-mono text-xs font-bold tracking-widest text-inkblue">{s.n}</span>
            <s.icon size={22} strokeWidth={1.8} className="text-ink/35 transition-colors duration-300 group-hover:text-inkblue" />
        </div>
        <div className="relative">
            <h3 className="font-display text-lg font-bold leading-snug text-ink">
                <span className="bg-gradient-to-r from-hl to-hl bg-[length:0%_45%] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 ease-out group-hover:bg-[length:100%_45%]">
                    {s.title}
                </span>
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-ink/60">{s.desc}</p>
        </div>
    </motion.div>
);

export const Services = () => (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32">
        <div className="mx-auto max-w-6xl px-5 lg:px-8">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
                <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-inkblue">Services — 01 → 08</p>
                <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                    Everything your queue needs.
                </h2>
                <p className="mt-3 rotate-[-1.5deg] font-hand text-2xl text-inkblue">
                    one system, eight moving parts
                </p>
            </motion.div>
            <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {SERVICES.map((s, i) => (
                    <Card key={s.n} s={s} i={i} />
                ))}
            </div>
        </div>
    </section>
);
